const SCORE_COLORS = ['success', 'warning', 'danger', 'secondary'];
const QUALITY_MODAL_PARAM = 'modal';
const QUALITY_MODAL_VALUE = 'quality-score';

const cleanText = (value) => {
    const container = document.createElement('div');
    container.innerHTML = value || '';
    return (container.textContent || '').trim();
};

const characterRules = (form) => {
    const value = (name) => {
        const field = form.elements.namedItem(name);
        if (!field) {
            return '';
        }

        return field.value || '';
    };
    const length = (name) => Array.from(cleanText(value(name))).length;
    const wordCount = (name) => (cleanText(value(name)).match(/[\p{L}\p{N}][\p{L}\p{N}'’-]*/gu) || []).length;
    const filled = (name) => cleanText(value(name)) !== '';
    const filledCount = (names) => names.filter(filled).length;

    const height = Number(value('character_height'));
    const weight = Number(value('character_weight'));
    const validDimensions = filled('character_height')
        && filled('character_weight')
        && height >= 3
        && height <= 8
        && weight >= 60
        && weight <= 600;

    const options = {};
    form.querySelectorAll('[name]').forEach((field) => {
        const fieldName = field.getAttribute('name') || '';
        const match = fieldName.match(/^(initial_options(?:_\d+)?)\[(label|value)\]$/);
        if (!match) {
            return;
        }

        options[match[1]] = options[match[1]] || {};
        options[match[1]][match[2]] = cleanText(field.value);
    });
    const validOptions = Object.values(options).filter((option) => option.label && option.value).length;

    const tags = form.querySelector('[name="tags[]"]');
    const tagCount = tags
        ? Array.from(tags.selectedOptions || []).filter((option) => option.value).length
        : 0;

    const media = {
        cover_images: 0,
        public_images: 0,
        public_videos: 0,
        public_audio: 0,
        premium_images: 0,
        premium_videos: 0,
        premium_audio: 0,
    };

    form.querySelectorAll('.image-uploader .uploaded-image').forEach((item) => {
        const access = item.dataset.imageType || 'cover';
        const kind = item.classList.contains('is-audio')
            ? 'audio'
            : (item.classList.contains('is-video') ? 'videos' : 'images');

        if (access === 'cover' && kind === 'images') {
            media.cover_images += 1;
        } else if (access === 'public' && media[`public_${kind}`] !== undefined) {
            media[`public_${kind}`] += 1;
        } else if (access === 'premium' && media[`premium_${kind}`] !== undefined) {
            media[`premium_${kind}`] += 1;
        }
    });

    return [
        filled('character_title') && filled('character_gender'),
        length('character_summary') >= 40,
        length('character_introduction') >= 80,
        length('character_description') >= 180,
        length('character_personality') >= 30 && wordCount('character_personality') >= 4,
        length('character_personality') >= 80,
        length('character_gpt_personality_extension') >= 80,
        filledCount(['character_occupation', 'character_hobbies', 'character_dreams']) >= 2,
        validDimensions,
        filledCount(['character_age', 'character_eye_color', 'character_hair_style', 'character_hair_color', 'character_ethnicity']) >= 4,
        length('character_intro_message') >= 80 && validOptions >= 2,
        media.cover_images >= 3,
        media.public_images >= 10,
        media.public_videos >= 10,
        media.public_audio >= 5,
        media.premium_images >= 10,
        media.premium_videos >= 10,
        media.premium_audio >= 5,
        tagCount >= 2,
    ];
};

const roleplayRules = (form) => {
    const value = (name) => {
        const field = form.elements.namedItem(name);
        return field ? (field.value || '') : '';
    };
    const length = (name) => Array.from(cleanText(value(name))).length;
    const filled = (name) => cleanText(value(name)) !== '';

    const rawCharacters = cleanText(value('character_slugs'));
    let characterCount = 0;
    if (rawCharacters) {
        try {
            const decoded = JSON.parse(rawCharacters);
            characterCount = Array.isArray(decoded) ? decoded.filter(Boolean).length : 0;
        } catch (error) {
            characterCount = rawCharacters.split(',').map((item) => item.trim()).filter(Boolean).length;
        }
    }

    const options = {};
    form.querySelectorAll('[name]').forEach((field) => {
        const fieldName = field.getAttribute('name') || '';
        const match = fieldName.match(/^(initial_options(?:_\d+)?)\[(label|value)\]$/);
        if (!match) {
            return;
        }

        options[match[1]] = options[match[1]] || {};
        options[match[1]][match[2]] = cleanText(field.value);
    });
    const validOptions = Object.values(options).filter((option) => option.label && option.value).length;

    const tags = form.querySelector('[name="roleplay_tags[]"]');
    const tagCount = tags
        ? Array.from(tags.selectedOptions || []).filter((option) => option.value).length
        : 0;

    const media = {
        cover_images: 0,
        public_images: 0,
        public_videos: 0,
        public_audio: 0,
        premium_images: 0,
        premium_videos: 0,
        premium_audio: 0,
    };

    form.querySelectorAll('.image-uploader .uploaded-image').forEach((item) => {
        const access = item.dataset.imageType || 'cover';
        const kind = item.classList.contains('is-audio')
            ? 'audio'
            : (item.classList.contains('is-video') ? 'videos' : 'images');

        if (access === 'cover' && kind === 'images') {
            media.cover_images += 1;
        } else if (access === 'public' && media[`public_${kind}`] !== undefined) {
            media[`public_${kind}`] += 1;
        } else if (access === 'premium' && media[`premium_${kind}`] !== undefined) {
            media[`premium_${kind}`] += 1;
        }
    });

    return [
        filled('post_title'),
        length('roleplay_summary') >= 40,
        characterCount >= 1,
        length('summary') >= 80,
        length('current_scene') >= 120,
        length('full_backstory') >= 200,
        length('current_details') >= 60 && length('world_state_facts') >= 60,
        length('guiding_prompt') >= 60
            && filled('writing_style')
            && filled('narrative_focus')
            && filled('narrative_perspective'),
        length('initial_options_message') >= 12 && validOptions >= 2,
        media.cover_images >= 3,
        media.public_images >= 10,
        media.public_videos >= 10,
        media.public_audio >= 5,
        media.premium_images >= 10,
        media.premium_videos >= 10,
        media.premium_audio >= 5,
        tagCount >= 2,
    ];
};

const scorePresentation = (score) => {
    if (score >= 90) {
        return {level: 'Excellent', color: 'success'};
    }
    if (score > 70) {
        return {level: 'Good', color: 'success'};
    }
    if (score >= 50) {
        return {level: 'Developing', color: 'warning'};
    }
    return {level: 'Needs work', color: 'danger'};
};

const setColor = (element, prefix, color) => {
    if (!element) {
        return;
    }
    SCORE_COLORS.forEach((candidate) => element.classList.remove(`${prefix}-${candidate}`));
    element.classList.add(`${prefix}-${color}`);
};

const setVisible = (element, visible) => {
    element.hidden = !visible;
    element.classList.toggle('d-none', !visible);
};

const renderCompletedRules = (container, rules, completed) => {
    container.replaceChildren();

    completed.forEach((index) => {
        const rule = rules[index];
        const column = document.createElement('div');
        column.className = 'col-12 col-md-6';

        const row = document.createElement('div');
        row.className = 'd-flex align-items-center gap-2 small py-1';

        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.className = 'form-check-input mt-0 flex-shrink-0';
        checkbox.checked = true;
        checkbox.disabled = true;
        checkbox.setAttribute('aria-label', `${rule.label} completed`);

        const details = document.createElement('div');
        details.className = 'd-flex justify-content-between gap-2 flex-grow-1';
        const label = document.createElement('span');
        label.textContent = rule.label;
        const points = document.createElement('span');
        points.className = 'text-muted text-nowrap';
        points.textContent = `${rule.max_points}/${rule.max_points}`;

        details.append(label, points);
        row.append(checkbox, details);
        column.append(row);
        container.append(column);
    });
};

const updateComponent = (button, form, rules) => {
    const modal = document.querySelector(button.dataset.bsTarget);
    if (!modal) {
        return;
    }

    const completedState = button.dataset.qualityType === 'roleplay'
        ? roleplayRules(form)
        : characterRules(form);
    const completed = [];
    const missing = [];
    let score = 0;

    rules.forEach((rule, index) => {
        if (completedState[index]) {
            completed.push(index);
            score += Number(rule.max_points) || 0;
        } else {
            missing.push(index);
        }
    });

    const presentation = scorePresentation(score);
    button.setAttribute('aria-label', `View quality score details: ${score}%`);

    document.querySelectorAll(`[data-quality-score-for="${modal.id}"]`).forEach((element) => {
        element.textContent = `${score}%`;
        setColor(element, 'text', presentation.color);
    });

    const level = modal.querySelector('[data-quality-level]');
    const points = modal.querySelector('[data-quality-points]');
    const progress = modal.querySelector('[data-quality-progress]');
    const progressBar = modal.querySelector('[data-quality-progress-bar]');
    const missingSection = modal.querySelector('[data-quality-missing-section]');
    const completeState = modal.querySelector('[data-quality-complete-state]');
    const completedSection = modal.querySelector('[data-quality-completed-section]');

    level.textContent = presentation.level;
    points.textContent = `${score} / 100 points`;
    progress.setAttribute('aria-valuenow', String(score));
    progressBar.style.width = `${score}%`;
    setColor(progressBar, 'bg', presentation.color);

    setVisible(missingSection, missing.length > 0);
    setVisible(completeState, missing.length === 0);
    setVisible(completedSection, completed.length > 0);

    modal.querySelector('[data-quality-missing-summary]').textContent = missing.length === 1
        ? `Complete 1 item to earn the remaining ${100 - score} points.`
        : `Complete ${missing.length} items to earn the remaining ${100 - score} points.`;
    modal.querySelector('[data-quality-missing-count]').textContent = `${missing.length} left`;
    modal.querySelector('[data-quality-completed-count]').textContent = `${completed.length} / ${rules.length}`;

    const missingRows = Array.from(modal.querySelectorAll('[data-quality-missing-rule]'));
    missingRows.forEach((row) => {
        const index = Number(row.dataset.qualityMissingRule);
        setVisible(row, missing.includes(index));
        row.classList.remove('border-bottom');
    });
    missing.forEach((index, position) => {
        const row = missingRows.find((candidate) => Number(candidate.dataset.qualityMissingRule) === index);
        if (!row) {
            return;
        }
        row.querySelector('[data-quality-step-number]').textContent = String(position + 1);
        row.classList.toggle('border-bottom', position < missing.length - 1);
    });

    renderCompletedRules(modal.querySelector('[data-quality-completed-list]'), rules, completed);
};

const initComponent = (button) => {
    const form = document.querySelector(`form.growtype-form[data-name="${button.dataset.qualityForm}"]`);
    const modal = document.querySelector(button.dataset.bsTarget);
    const config = modal ? modal.querySelector('[data-quality-rules]') : null;
    if (!form || !config) {
        return;
    }

    let rules;
    try {
        rules = JSON.parse(config.textContent);
    } catch (error) {
        return;
    }

    let updateTimer;
    const scheduleUpdate = () => {
        window.clearTimeout(updateTimer);
        updateTimer = window.setTimeout(() => updateComponent(button, form, rules), 80);
    };

    form.addEventListener('input', scheduleUpdate);
    form.addEventListener('change', scheduleUpdate);

    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(form, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'data-image-type'],
    });

    updateComponent(button, form, rules);
};

const initModalDeepLink = (button) => {
    const modal = document.querySelector(button.dataset.bsTarget);
    if (!modal) {
        return;
    }

    const updateUrl = (isOpen) => {
        const url = new URL(window.location.href);
        if (isOpen) {
            url.searchParams.set(QUALITY_MODAL_PARAM, QUALITY_MODAL_VALUE);
        } else if (url.searchParams.get(QUALITY_MODAL_PARAM) === QUALITY_MODAL_VALUE) {
            url.searchParams.delete(QUALITY_MODAL_PARAM);
        } else {
            return;
        }
        window.history.replaceState(window.history.state, '', url.toString());
    };

    modal.addEventListener('shown.bs.modal', () => updateUrl(true));
    modal.addEventListener('hidden.bs.modal', () => updateUrl(false));

    const requestedModal = new URL(window.location.href).searchParams.get(QUALITY_MODAL_PARAM);
    if (requestedModal !== QUALITY_MODAL_VALUE) {
        return;
    }

    window.setTimeout(() => {
        if (window.bootstrap?.Modal) {
            window.bootstrap.Modal.getOrCreateInstance(modal).show();
            return;
        }
        button.click();
    }, 0);
};

export function contentQualityScore() {
    document.querySelectorAll('.content-quality-score[data-bs-target]').forEach((button) => {
        initModalDeepLink(button);
        if (button.dataset.contentQualityLive === 'true') {
            initComponent(button);
        }
    });
}
